import React from 'react';
import App, {URL_HELPER} from './App';
import {OktaAuth, toRelativeUrl} from "@okta/okta-auth-js";
import {Security} from "@okta/okta-react";
import {getOktaAuth} from "./getOktaAuth";
import {BrowserRouter} from "react-router-dom";
import {render} from 'react-dom';
import {Configuration, DamOktaApiApi} from "./api";
import {OktaEnvContext} from "./OktaEnvContext";
import {ErrorBoundary} from "react-error-boundary";
import Footer from "./components/Footer";

function renderError(message: string) {
    return <div className="portal-app">
        <main className="p-4 text-danger">
            <h1>Error</h1>
            <p>{message}</p>
        </main>
        <Footer/>
    </div>;
}

(async () => {

    const root = document.querySelector("#root");

    try {
        await URL_HELPER.init();
    } catch (e) {
        console.error(e);
        render(renderError("Failed to connect to media center."), root);
        return;
    }

    function restoreOriginalUri(oktaAuth: OktaAuth, originalUri: string | undefined) {
        window.location.replace(toRelativeUrl(originalUri || '/', window.location.origin));
    }

    try {
        const oktaApi = new DamOktaApiApi(new Configuration({basePath: URL_HELPER.getApiUrl()}));
        const oktaConfig = await oktaApi.getOktaConfig();
        const oktaAuth = getOktaAuth(oktaConfig.issuer, oktaConfig.clientId);

        // check if user has an okta session
        if (oktaAuth) {
            if (window.location.pathname !== '/login-success'
                && !await oktaAuth.isAuthenticated()
                && await oktaAuth.session.exists()
            ) {
                // user is not signed in but there is an existing okta session -> sign in without prompt
                oktaAuth.signInWithRedirect({originalUri: window.location.href});
            }
        }

        render(
            <React.StrictMode>
                <ErrorBoundary fallback={renderError("Application Error.")}>
                    <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
                        <BrowserRouter>
                            <OktaEnvContext.Provider value={oktaConfig}>
                                <App/>
                            </OktaEnvContext.Provider>
                        </BrowserRouter>
                    </Security>
                </ErrorBoundary>
            </React.StrictMode>,
            root);
    } catch (e) {
        console.error(e);
        render(renderError("Application failed to initialize"), root);
    }
})();
